import { render, staticRenderFns } from "./pedProd.vue?vue&type=template&id=dcdae512&"
import script from "./pedProd.vue?vue&type=script&lang=js&"
export * from "./pedProd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports